export default __webpack_public_path__ + "static/media/logo.ccc60e94.jpg";